import { onCleanup, onMount } from 'solid-js'
import { canAnimate, trackKeyframes, type MotionTrack } from '~/lib/motion'

// The light band of a Shop shimmer (GLOSSARY.md "Starter pack shimmer (掃光)",
// "First-purchase bonus (首購翻倍)"): a 30% white strip with a soft white glow,
// pivoting on its top-left corner as the design's layer does, over the whole
// surface (the surface clips it). It plays its tracks on a loop of cycleMs
// from the moment it mounts and stops when it unmounts, so a surface that
// appears again starts over. Without the Web Animations API, or for a user
// who asked for reduced motion, it stays invisible.
export function ShimmerBand(props: {
  cycleMs: number
  testId: string
  tracks: MotionTrack[]
}) {
  let band: HTMLDivElement | undefined
  onMount(() => {
    if (!band || !canAnimate(band)) return
    const animations = props.tracks.map((track) =>
      band!.animate(trackKeyframes(track), {
        duration: props.cycleMs,
        iterations: Infinity,
      }),
    )
    onCleanup(() => {
      for (const animation of animations) animation.cancel()
    })
  })
  return (
    <div
      ref={(element) => {
        band = element
      }}
      data-testid={props.testId}
      aria-hidden="true"
      class="pointer-events-none absolute left-[-250px] top-[-100px] h-[620px] w-[110px] origin-top-left bg-white/30 opacity-0 shadow-[0_0_30px_rgba(255,255,255,0.25)] [rotate:-18deg]"
    />
  )
}
